<template lang="pug">
  .address-layout
    .header.white
      v-container.pa-0(style="max-width:600px")
        head-bar
    v-layout.my-6
      y-dialog(v-model='isLoading' persistent width='300')
        v-card(v-if="!hasResult" color='primary' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('processing_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('processing_text') }}

        v-card(v-if="isSuccess" color='success' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('success_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('success_text') }}

        v-card(v-if="isError" color='error' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('error_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('error_text') }}

</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'
import HeadBar from '@/components/forms/HeadBar.vue'
export default {
  name: 'AddressFrom',
  components: { HeadBar },
  props: ['lead'],
  data: () => ({
    isVerifying: true,
    isLoading: true,
    hasResult: false,
    isSuccess: false,
    isError: false,
    verifyingInterval: null,
    tryCount: 0,
    reDirectUrl: ''
  }),

  mounted () {
    if (this.lead.form.company.tracker) {
      this.initPixel(this.lead.form.company.tracker)
    }
    this.tryCount = 1
    this.verifyingInterval = setInterval(() => {
      this.$axios.post(`/leads/${this.lead.pid}/recheck_payments/`)
      this.$axios.get(`/leads/${this.lead.pid}/`)
      .then(resp => {
        const lead = resp.data

        if (lead.paid === true) {
          if (lead.form.company.tracker) {
            this.trackGtag(lead.form.company.tracker, lead)
            this.trackPixel(lead.form.company.tracker, lead)
          }
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(true)
          this.reDirectUrl = `/invoices/${this.lead.pid}/`
        } else if (lead.status == 'partial_payment') {
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(true)
          this.reDirectUrl = this.reDirectUrl = `/invoices/${this.lead.pid}/`
        } else {
          if (this.$route.query.retry) {
            this.reDirectUrl = `/invoices/${this.lead.pid}/?error=true&retry=true`
          } else {
            this.reDirectUrl = `/invoices/${this.lead.pid}/?error=true`
          }
        }

      })
      .catch(() => {})
      .finally(() => {
        if (this.tryCount >= 5 && this.isVerifying) {
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(false)
        }
        this.tryCount++
      })
    }, 1500)
  },

  methods: {
    showResult (result) {
      this.hasResult = true
      if (result) {
        this.isSuccess = true
      } else {
        this.isError = true
      }
      setTimeout(() => {
        location.href = this.reDirectUrl
      }, 2000)
    },

    calculatePurchaseAmount (lead) {
      const subtotalAmount = lead.products.reduce((sum, p) => {
          return sum + ((p.price - p.discount) * p.quantity)
        }, 0)
      const taxAmount = subtotalAmount * lead.form.company.tax_rate / this.$currency.multiplier
      const shippingFee = lead.shipping ? lead.shipping.fee : 0
      return subtotalAmount + taxAmount + shippingFee
    },

    trackGtag (tracker, lead) {
      if (!tracker.ga) {
        return
      }
      setOptions({
        config: { id: tracker.ga }
      })
      bootstrap().then(() => {
        this.$gtag.event('purchase', {
          transaction_id: lead.pid,
          affiliation: 'Yezza',
          value: this.calculatePurchaseAmount(lead),
          currency: this.$currency.code
        })
      })
    },

    initPixel (tracker) {
      if (!tracker.fb) {
        return
      }
      window.fbq('init', tracker.fb)
      //window.fbq('trackSingle', tracker.fb, 'PageView')
    },
    trackPixel (tracker, lead) {
      if (!tracker.fb) {
        return
      }

      /* Update purchase */
      window.fbq('trackSingle', tracker.fb, 'Purchase', {
        value: this.calculatePurchaseAmount(lead)/this.$currency.multiplier,
        currency: this.$currency.code
      }, {eventID: `yz.l.${lead.pid}`})
    }
  }
}
</script>

<style scoped>
.header {
  background: #F8F9FC;
  padding: 16px;
}
.content {
  padding: 16px;
}
</style>

<i18n>
{
  "en": {
    "processing_title": "Verifying payment...",
    "processing_text": "Please wait and do not close or refresh this page",
    "success_title": "Thank you!",
    "success_text": "Your payment is successful",
    "error_title": "Ops..",
    "error_text": "Your payment did not go through. Please try again later."
  },
  "id": {
    "processing_title": "Memverifikasi pembayaran...",
    "processing_text": "Harap tunggu dan jangan tutup atau segarkan halaman ini",
    "success_title": "Terima kasih!",
    "success_text": "Pembayaran kamu berhasil",
    "error_title": "Ops..",
    "error_text": "Pembayaran kamu tidak berhasil. Silakan coba lagi nanti."
  }
}
</i18n>
